import { useI18n } from "@/i18n/I18nProvider";

export default function Footer() {
    const { t } = useI18n();
    const f = t.footer;
    const year = new Date().getFullYear();
    return (
        <footer
            data-testid="footer"
            className="border-t border-white/5 bg-[#04140D] py-10"
        >
            <div className="max-w-[1400px] mx-auto px-6 md:px-12 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
                <div className="flex items-center gap-2.5">
                    <span className="h-8 w-8 rounded-md bg-[#D4FF00] grid place-items-center text-[#04140D] font-display font-bold">
                        D
                    </span>
                    <span className="font-display font-bold text-base tracking-tight">
                        Davini<span className="text-[#D4FF00]">.ai</span>
                    </span>
                </div>
                <div className="text-xs text-white/40 uppercase tracking-widest font-semibold">
                    {f.copyright.replace("{year}", year)}
                </div>
                <div className="flex items-center gap-5 text-xs text-white/45 uppercase tracking-widest font-semibold">
                    <a href="#problem" className="hover:text-[#D4FF00]">
                        {f.product}
                    </a>
                    <a href="#pricing" className="hover:text-[#D4FF00]">
                        {f.pricing}
                    </a>
                    <a href="#team" className="hover:text-[#D4FF00]">
                        {f.team}
                    </a>
                </div>
            </div>
        </footer>
    );
}
